module.exports = "/assets/7a630f0dadc393a2112b82248079faca.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/EN.png
// module id = 1342
// module chunks = 0